<template>
    <ResourceInput
        label="Lede"
        attribute="lede"
        type="richtext"
    />
</template>
